import { SubscriptionPlanModel } from "../../../models/subscription-plan.model";
import { ItemMapper } from "../../../lib/item-mapper";

export class SubscribeUserMapper extends ItemMapper<SubscriptionPlanModel> {
  //   public imgPrefix = "https://d1vf2jccr14y1d.cloudfront.net/covers/";
  protected mapFromItem(item): SubscriptionPlanModel {
    console.log(item);
    const planModel = new SubscriptionPlanModel();
    planModel.planId = item._id;
    planModel.planName = item.name;
    planModel.planMonthly = item.monthlyPrice;
    planModel.playerSlot = item.playerSlot;
    planModel.stripePriceId = item.stripePriceId;
    planModel.planYear = item.price;
    planModel.subscribed = item.subscribed;
    planModel.currency = item.currency;
    planModel.interval = item.interval;
    planModel.apikey = item.apikey;
    planModel.createdAt = item.createdAt;
    planModel.active = item.active;

    console.log(planModel);
    // profileImage
    return planModel;
  }
}
